// App.tsx - Updated
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Master from "./MasterLayout/Master";
import { AdminRoutes } from "./Route";
import "./App.css";
import PrivateRoute from "./Auth/privateRoute";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Login from "./Auth/Login";
import { AuthProvider } from "./Auth/AuthContext";
import Register from "./Auth/Register";
import { SettingsProvider } from "./Pages/Settings/SettingContext";
import GlobalReminderChecker from "./Pages/Calendar/GlobalReminderChecker";
import ApplyJob from "./Pages/AddJobApplication/ApplyJob";
import { NotificationProvider } from "./Context/NotificationContext";
import { SocketProvider } from "./Context/SocketContext";
import SocketNotificationHandler from "./Context/SocketNotificationHandler";

const App: React.FC = () => {
  return (
    <AuthProvider>
      <SettingsProvider>
        <NotificationProvider>
          <SocketProvider>
            <SocketNotificationHandler />
            {/* <Notifications /> */}
            <BrowserRouter>
              <GlobalReminderChecker />
              <Routes>
                <Route path="/job-apply" element={<ApplyJob />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route element={<PrivateRoute children={<Dashboard />} />}>
                  {AdminRoutes.map((route) => (
                    <Route
                      key={route.path}
                      path={route.path}
                      element={<Master children={<route.component />} />}
                    />
                  ))}
                </Route>
              </Routes>
            </BrowserRouter>
          </SocketProvider>
        </NotificationProvider>
      </SettingsProvider>
    </AuthProvider>
  );
};

export default App;
